<template>
    <div :class="['sidebar', mobileView ? 'mobile' : '']">
        <Slide v-if="mobileView" class="sidebar--mobile" disableEsc :closeOnNavigation="true" noOverlay>
            <SidebarLinks mobile="true" />
        </Slide>
        <div v-else class="sidebar--desktop">
            <SidebarLinks />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import SidebarLinks from './SidebarLinks.vue'
import { Slide } from 'vue-burger-menu'

export default {
    name: 'Sidebar',
    components: {
        SidebarLinks,
        Slide
    },
    data: () => {
        return {
            mobileView: false
        }
    },
    methods: {
        handleView() {
            this.mobileView = window.innerWidth <= 800
        }
    },
    created() {
        this.handleView()
        window.addEventListener('resize', this.handleView)
    }
}
</script>

<style scoped>
h5 {
    text-transform: uppercase;
    font-size: 1rem;
    font-weight: 700;
    color: #020202;
    margin: 0;
}

a {
    display: block;
    padding: 4px 32px 4px 4px;
    color: inherit;
    text-decoration: none;
    border-left: 2px solid rgba(33, 150, 243, 0);
    text-transform: none;
    font-size: 0.875rem;
    font-weight: 400;
}

a:hover {
    background-color: rgba(0, 0, 0, 0.04);
    color: #4a18c6;
}

.sidebar {
    flex: 0 0 auto;
    border-right: 1px solid var(--sidebar-border);
    min-width: 180px;
    width: 220px;
}

.mobile.sidebar {
    width: 0;
    min-width: 0;
    flex: unset;
}

.sidebar--section {
    margin: 0 0 16px 0;
    padding: 0;
}

.sidebar--section > a,
.sidebar--section > h5 {
    padding-left: 16px;
}

.router-link-active {
    border-left: 2px solid rgba(92, 32, 243, 0.9);
}
</style>
